// Libraries
var React = require('react');
var Slider = null;

// Styles
require('./KeyMoments.scss');

// Components
var Slide = require('Highlights/Slide');

class KeyMoments extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			events: [],
			showSelf: false,
			notifications: 0,
			selectedEventIndex: 0
		}

		this.settings = {
			dots: false,
			infinite: false,
			arrows: true,
			speed: 500,
			autoplay: false,
			slidesToShow: 1,
			slidesToScroll: 1,
			draggable: true,
			waitForAnimate: true
		};
	};

	componentDidMount() {
		Slider = require('react-slick').default;

		if(this.props.events.length > 0) {
			this.initialLoad(this.props.events, this.props.selectedEventId);
		}
	}

	eventChanged = (eventId) => {
		if(this.slider) {
			let newSlideIndex = this.state.events.findIndex(x => x.Id === eventId)
			this.slider.slickGoTo(newSlideIndex);

			// jumping forward --> mark all past events as 'read'
			let updatedEvents = this.state.events.map((event, index) => {
				if(newSlideIndex > this.state.selectedEventIndex) {
					if(index <= newSlideIndex) {
						event.read = true;
					}
				}
				return event;
			});

			this.setState({
				selectedEventIndex: newSlideIndex, 
				events: updatedEvents, 
				notifications: updatedEvents.filter(x => x.read === false).length 
			});
		}
	};

	initialLoad = (events, selectedEventId) => {
		// on first load --> set every event to 'unread' after the initial slide
		let allEvents = events.map((event, index) => {
			event.read = true;
			return event;
		});

		this.setState({
			showSelf: true,
			selectedEventIndex: selectedEventId ? events.findIndex(x => x.Id === selectedEventId) : 0,
			events: allEvents,
			notifications: 0
		});
	}

	componentWillReceiveProps(nextProps) {
		// this can be called even if props haven't changed
		if(this.props.events !== nextProps.events) {

			if(this.state.events.length === 0) {
				this.initialLoad(nextProps.events, nextProps.events.length > 0 ? nextProps.events[nextProps.events.length - 1].Id : undefined);
			} else {
				// on subsequent updates to the collection of events --> set new events that are after the currently visible event to 'unread'
				let eventsWithState = nextProps.events.map((newEvent, index) => {
					if(index > this.state.selectedEventIndex && this.state.events.findIndex(x => x.Id === newEvent.Id) === -1) {
						newEvent.read = false;
					}
					return newEvent;
				});

				this.setState({events: eventsWithState, notifications: eventsWithState.filter(x => x.read === false).length });
			}
		}

		if(this.props.selectedEventId !== nextProps.selectedEventId) {
			// make sure the slider has been rendered before changing state
			this.setState({ showSelf: true }, () => { this.eventChanged(nextProps.selectedEventId); });
		}
	};

	handleSliderAfterChange = (newIndex) => {
		// this must be called after slider has changed otherwise the animation is cancelled
		this.props.selectedEventChanged(this.state.events[newIndex].Id);

		let updatedEvents = this.state.events.slice();
		updatedEvents[newIndex].read = true;

		this.setState({ 
			events: updatedEvents, 
			notifications: updatedEvents.filter(x => x.read === false).length 
		});
	};

	toggleKeyMoments = () => {
		let isOpen = this.state.showSelf;
		this.setState({ showSelf: !this.state.showSelf });

		if(isOpen) {
			// closing
			this.props.unselectEvents();
		} else {
			// opening
			let index = this.state.events[this.state.selectedEventIndex].Id;
			this.props.selectedEventChanged(index);
		}
	};

	generateBackground = () => {
		if(this.state.events.length > 0) {
			let selectedEvent = this.state.events[this.state.selectedEventIndex];
			if(selectedEvent) {
				if(selectedEvent.Type === "Goal") {
					return " KeyMoments--goal";
				}
				if(selectedEvent.Type === "Substitution") {
					return " KeyMoments--substitution";
				}
				if(selectedEvent.Type === "Booking" && selectedEvent.CardType === "YellowCard") {
					return " KeyMoments--yellowcard";
				}
				if(selectedEvent.Type === "Booking" && selectedEvent.CardType === "RedCard") {
					return " KeyMoments--redcard";
				}
				if (selectedEvent.Type === "Booking" && selectedEvent.CardType === "YellowRedCard") {
					return " KeyMoments--yellowredcard";
				}
			}
		}
		return "";
	}

	render() {
		return (
			<div className={"KeyMoments" + (this.state.showSelf ? this.generateBackground() : "")}>

				{this.state.events.length > 0 ? (
					<button className={"KeyMoments__button KeyMoments__button--toggle" + (this.state.showSelf ? " is-open" : "")} onClick={this.toggleKeyMoments}>{this.state.showSelf ? "Close Key Moments" : "Open Key Moments"}</button>
				) : (
					<button className={"KeyMoments__button KeyMoments__button--noarrow"}>Key moments will appear here</button>
				)}

				{this.state.showSelf && this.state.events.length > 0 &&
						<div>
							<Slider ref={(slider) => { this.slider = slider; }} {...this.settings} initialSlide={this.state.selectedEventIndex} afterChange={this.handleSliderAfterChange}>
								{this.state.events.map((event, index) => {
									let crest = event.IsHomeTeam ? this.props.homeCrestUrl : this.props.awayCrestUrl;
									return(
										<div key={index}> {/* Needs to be wrapped in a div due to a bug in the library */}
											<Slide tabIndex={this.state.selectedEventIndex === index ? "0" : "-1"} event={event} crestUrl={crest} />
										</div>
									)
								})}
							</Slider>
							{this.state.notifications > 0 &&
									<div className="KeyMoments__notifications">
										<span>{this.state.notifications}</span> <span>new moments</span>
									</div>
							}
						</div>
				}
			</div>
		)
	};
}

module.exports = KeyMoments;



// WEBPACK FOOTER //
// ./src/components/MDC/Timeline/KeyMoments.js